import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import Isvg from 'react-inlinesvg';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import media from 'decorators/Media/Media';
import { decorateWith, withName } from 'helpers/decorator';
import { isEmpty } from 'helpers/verify';

const CLOSE_AFTER_MOUSELEAVE_TIME = 750;

export const LINKS = {
  blog: (
    <li>
      <a href="/blog" target="_blank" rel="noopener noreferrer">
        <FormattedMessage id="header.link.blog" defaultMessage="Blog" />
      </a>
    </li>
  ),
  features: (
    <li>
      <Link to="/features">
        <FormattedMessage id="header.link.features" defaultMessage="How it works" />
      </Link>
    </li>
  ),
  locations: (
    <li>
      <Link to="/locations">
        <FormattedMessage id="header.link.locations" defaultMessage="Locations" />
      </Link>
    </li>
  ),
  pricing: (
    <li>
      <Link to="/pricing">
        <FormattedMessage id="header.link.pricing" defaultMessage="Pricing" />
      </Link>
    </li>
  ),
  search: (
    <li>
      <Link to="/search">
        <FormattedMessage id="header.link.explore" defaultMessage="Explore studios" />
      </Link>
    </li>
  ),
};

export const LINKS_NAMES = {
  blog: 'blog',
  features: 'features',
  locations: 'locations',
  pricing: 'pricing',
  search: 'search',
};
export const SEARCH__PAGE_LINK_ORDER = [
  LINKS_NAMES.features,
  LINKS_NAMES.pricing,
  LINKS_NAMES.locations,
  LINKS_NAMES.blog,
];
export const DEFAULT_LINK_ORDER = [LINKS_NAMES.search, ...SEARCH__PAGE_LINK_ORDER];

export class SellPageLinksUnwrapped extends Component {
  state = { dropdownOpen: false };

  handleMouseLeave = () => (this.timer = setTimeout(this.toggleDropdown, CLOSE_AFTER_MOUSELEAVE_TIME));

  handleMouseEnter = () => {
    const { dropdownOpen } = this.state;

    clearTimeout(this.timer);

    if (!dropdownOpen) {
      this.toggleDropdown();
    }
  };

  toggleDropdown = () =>
    this.setState(state => ({
      dropdownOpen: !state.dropdownOpen,
    }));

  renderLink(name) {
    const link = LINKS[name];
    return link && <Fragment key={name}>{link}</Fragment>;
  }

  render() {
    const { collapsedLinks, spreadLinks } = this.props;
    const { dropdownOpen } = this.state;

    return (
      <Fragment>
        {spreadLinks.map(this.renderLink)}
        {!isEmpty(collapsedLinks) && (
          <li className="header__dropdown" onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
            <div
              className={classNames({
                header__dropdown__target: true,
                'header__dropdown__target--open': dropdownOpen,
              })}>
              <FormattedMessage tagName="strong" id="nav.more" defaultMessage="More" />
              <Isvg
                className="header__dropdown__arrow svg ml-"
                uniquifyIDs={false}
                src={require('static/img/arrow.svg')}
              />
            </div>
            {dropdownOpen && (
              <div className="header__dropdown__panel">
                <ul>{collapsedLinks.map(this.renderLink)}</ul>
              </div>
            )}
          </li>
        )}
      </Fragment>
    );
  }
}

SellPageLinksUnwrapped.propTypes = {
  collapsedLinks: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(LINKS))).isRequired,
  spreadLinks: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(LINKS))).isRequired,
};

export const mapStateToProps = (state, props) => {
  const { hasSearchBar, isSearchPage, mediaQueryLg, mediaQueryXl } = props;

  const links = isSearchPage ? SEARCH__PAGE_LINK_ORDER : DEFAULT_LINK_ORDER;
  const spreadCount = hasSearchBar ? (mediaQueryXl && 2) || (mediaQueryLg && 1) || 0 : links.length;

  return {
    collapsedLinks: links.slice(spreadCount),
    spreadLinks: links.slice(0, spreadCount),
  };
};

export const SellPageLinks = decorateWith(connect(mapStateToProps), media, withName('SellPageLinks'))(
  SellPageLinksUnwrapped
);

SellPageLinks.propTypes = {
  hasSearchBar: PropTypes.bool.isRequired,
  isSearchPage: PropTypes.bool,
  mediaQueryLg: PropTypes.bool,
  mediaQueryXl: PropTypes.bool,
};
